// Formats time with dilation effects for reality layers
export const formatDilatedTime = (timeDilation) => {
  // Get current timestamp
  const now = Date.now();
  // Calculate time difference from a fixed reference point to avoid huge numbers
  const baseTime = new Date('2025-01-01').getTime();
  const timeDiff = now - baseTime;
  // Apply dilation to the difference only
  const dilatedDiff = timeDiff * (1 + (timeDilation || 0));
  // Add dilated difference back to base time
  const dilatedTime = baseTime + dilatedDiff;

  // Only keep lower bound to prevent negative years
  const minDate = new Date('1970-01-01').getTime();
  const boundedTime = Math.max(minDate, dilatedTime);
  const date = new Date(boundedTime);
  
  // Calculate year, handling dates beyond 9999
  const year = boundedTime > new Date('9999-12-31').getTime()
    ? 1970 + Math.floor((boundedTime - minDate) / (365.25 * 24 * 60 * 60 * 1000))
    : date.getFullYear();

  // Date format
  const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  const month = months[date.getMonth()];
  const day = String(date.getDate()).padStart(2, '0');
  
  // Time format
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  const centiseconds = String(Math.floor(date.getMilliseconds() / 10)).padStart(2, '0');
  
  // Add AM/PM
  const period = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12; // Convert 24h to 12h format
  
  return {
    date: `${day} ${month} ${year}`,
    time: `${displayHours}:${minutes}:${seconds}.${centiseconds} ${period}`
  };
};